import { PayloadAction } from '@reduxjs/toolkit'

import { RequestStatus } from 'clickNgo/configs/service/common'
import { IForm } from 'core-components/classes/models/IForm'

import { mapRequestFromCrud } from '../../services/mapping/mapRequestFromCrud'
import { IOnboardingState, IRequestActionParams } from '../models'

export const getRequestPending = (
  state: IOnboardingState,
  action: PayloadAction<unknown, string, { arg: IRequestActionParams }>
) => {
  const { meta } = action

  state.requestData.meta = meta
  state.requestData.status = RequestStatus.PENDING
  state.requestData.message = ''
}

export const getRequestRejected = (
  state: IOnboardingState,
  action: PayloadAction<unknown, string, { arg: IRequestActionParams }>
) => {
  const { meta } = action

  state.requestData.meta = meta
  state.requestData.status = RequestStatus.REJECTED
  state.requestData.message = action.payload as string
}

export const getRequestFulfilled = (
  state: IOnboardingState,
  action: PayloadAction<IForm | null, string, { arg: IRequestActionParams }>
) => {
  const { meta, payload } = action

  state.requestData.meta = meta
  state.requestData.status = RequestStatus.FULFILLED
  state.requestData.message = ''
  if (payload && payload.request) {
    state.requestData.data = mapRequestFromCrud(payload.request)
  }
}
